import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import api from '../api';
import { getAuthenticatedAccountId } from '../selectors/auth';
import { getBabiesSortedByName } from '../selectors/babies';
import getNextBabyColor from '../helpers/getNextBabyColor';

import BabyEdit from '../components/BabyEdit';

const BabyCreateContainer = ({ onBabyCreated }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { accountId, babiesCount } = useSelector((state) => ({
    accountId: getAuthenticatedAccountId(state),
    babiesCount: getBabiesSortedByName(state).length,
  }));

  useEffect(() => {
    dispatch(api.actions.babiesCreate.reset({}));
  }, [dispatch]);

  const handleSubmit = useCallback((values) => {
    dispatch(api.actions.babiesCreate.reset({}));

    return dispatch(api.actions.babiesCreate(
      { accountId },
      {
        body: JSON.stringify({
          ...values,
          admissionDate: values.admissionDate ? values.admissionDate : null,
          status: 'active',
          colorScheme: 'blue',
        }),
      }
    )).then(
      () => {
        if (onBabyCreated) onBabyCreated();
      },
      () => {
        return { FORM_ERROR: t('accountOptions.addBabyError') };
      }
    );
  }, [accountId, dispatch, onBabyCreated, t]);

  const initialValues = {
    colorScheme: getNextBabyColor(babiesCount),
  };

  return (
    <BabyEdit
      isNew
      initialValues={initialValues}
      onSubmit={handleSubmit}
    />
  );
};

BabyCreateContainer.propTypes = {
  onBabyCreated: PropTypes.func.isRequired,
};

export default BabyCreateContainer;
